import React, { Fragment } from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { isEmpty, last } from 'lodash';
import Big from 'big.js';

import logo from 'images/reason-percentage.png';
import { currencySymbolForPDF } from '../../../services/orderService';
import { formatMoney } from '../../../util/numberUtils';

import { getVariantsHowText } from '../../../util/utils';

const styles = StyleSheet.create({
  dFlex: {
    display: 'flex'
  },
  flexColumn: {
    flexDirection: 'column'
  },
  strikethroughText: {
    color: '#45535F',
    textDecoration: 'line-through'
  },
  variants: {
    flexDirection: 'row'
  },
  variantText: {
    fontSize: 8
  },
  table: {
    display: 'flex',
    width: '100%',
    fontSize: 9
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#E6E6E6',
    borderStyle: 'solid',
    padding: '5px 0px'
  },
  headerRow: {
    border: '0px',
    alignItems: 'center',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#2A4494',
    fontSize: 11,
    padding: '15px 0px'
  },
  tableCell: {
    wordBreak: 'break-word',
    whiteSpace: 'nowrap',
  },
  productCell: {
    flex: 2,
    textAlign: 'left',
  },
  skuCell: {
    flex: 1,
    textAlign: 'center',
  },
  quantityCell: {
    flex: 1,
    textAlign: 'center',
  },
  unitPriceCell: {
    flex: 1.5,
    textAlign: 'center',
  },
  taxCell: {
    flex: 1,
    textAlign: 'center',
  },
  totalCell: {
    flex: 1.5,
    textAlign: 'right',
    borderRightWidth: 0
  },
  textLeft: {
    textAlign: 'left'
  },
  discount: {
    fontSize: 8,
    color: '#546775'
  },
  logo: {
    width: 7,
    height: 7,
    marginRight: 10
  }
});

const InvoiceTableRow = ({ invoice, items, retailerInfo }) => {
  const symbol = currencySymbolForPDF(invoice);
  const currency = invoice.currency || retailerInfo.currency_code;

  const rows = items?.map((item) => (
    <View style={[styles.tableRow, { borderBottomWidth: last(items) == item ? 0 : 1 }]} key={item.id.toString()}>
      <View style={[styles.tableCell, styles.productCell]}>
        <Text>
          {`${item.title}`}
        </Text>
        {!isEmpty(item.variants) && (
          <Text style={styles.variantText}>{getVariantsHowText(item.variants)}</Text>
        )}
        {item.variant_name && (
          <Text style={styles.variantText}>{item.variant_name}</Text>
        )}
      </View>
      <View style={[styles.tableCell, styles.skuCell, styles.textLeft]}>
        {item.sku && (
          <Text style={styles.skuText}>
            {`${item.sku}`}
          </Text>
        )}
      </View>
      <Text style={[styles.tableCell, styles.quantityCell]}>{item.quantity}</Text>
      <View style={[styles.tableCell, styles.unitPriceCell]}>
        <Text>
          {symbol}
          {formatMoney(item.unit_price)}
          {' '}
          {currency}
        </Text>
      </View>
      <Text style={[styles.tableCell, styles.taxCell]}>
        {item.custom_tax ? item.custom_tax : 0}
        %
      </Text>
      <View style={[styles.tableCell, styles.totalCell]}>
        {Number(item.total_discount) > 0 ? (
          <View style={[styles.dFlex, styles.flexColumn]}>
            <Text>
              {symbol}
              {formatMoney(Number(Big(Number(item.total)).sub(Number(item.total_discount))))}
              {' '}
              {currency}
            </Text>
            <Text style={[styles.strikethroughText]}>
              {symbol}
              {formatMoney(item.total)}
            </Text>
            <Text style={[styles.discount]}>
              <Image style={styles.logo} src={logo} />
              Descuento
            </Text>
          </View>
        ) : (
          <Text>
            {symbol}
            {formatMoney(item.total)}
            {' '}
            {currency}
          </Text>
        )}
      </View>
    </View>
  ));
  return (
    <Fragment>
      <View style={styles.table}>
        <View style={[styles.tableRow, styles.headerRow]}>
          <Text style={[styles.tableCell, styles.productCell]}>Producto</Text>
          <Text style={[styles.tableCell, styles.skuCell, styles.textLeft]}>SKU</Text>
          <Text style={[styles.tableCell, styles.quantityCell]}>Cantidad</Text>
          <Text style={[styles.tableCell, styles.unitPriceCell]}>P.U.</Text>
          <Text style={[styles.tableCell, styles.taxCell]}>Impuesto</Text>
          <Text style={[styles.tableCell, styles.totalCell]}>Total</Text>
        </View>
        {rows}
      </View>
    </Fragment>
  );
};

export default InvoiceTableRow;
